import { createContext } from 'react';

type RouterProps = { path: string; params: { [key: string]: any } };

export const RouterContext = createContext({} as RouterProps);

export const RouterProvider = RouterContext.Provider;
